import a from "./internal/_curry1.mjs";
import o from "./internal/_has.mjs";
import c from "./internal/_isArguments.mjs";
var g = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), i = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], s = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), l = function(r, t) {
  for (var e = 0; e < r.length; ) {
    if (r[e] === t)
      return !0;
    e += 1;
  }
  return !1;
}, y = typeof Object.keys == "function" && !s ? /* @__PURE__ */ a(function(r) {
  return Object(r) !== r ? [] : Object.keys(r);
}) : /* @__PURE__ */ a(function(r) {
  if (Object(r) !== r)
    return [];
  var t, e, n = [], f = s && c(r);
  for (t in r)
    o(t, r) && (!f || t !== "length") && (n[n.length] = t);
  if (g)
    for (e = i.length - 1; e >= 0; )
      t = i[e], o(t, r) && !l(n, t) && (n[n.length] = t), e -= 1;
  return n;
});
export {
  y as default
};
